var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as Utils from './Utils';
const Jersey = (_a) => {
    var { sport, teamName, teamType, loadImage, imageUrl, size } = _a, rest = __rest(_a, ["sport", "teamName", "teamType", "loadImage", "imageUrl", "size"]);
    const [image, setImage] = React.useState(imageUrl !== null && imageUrl !== void 0 ? imageUrl : null);
    const mounted = React.useRef(true);
    React.useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    React.useEffect(() => {
        if (image)
            return;
        (function load() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const trimmedSport = sport.replace(/\s/g, '');
                    const maybeSize = size ? `${size}/` : '';
                    Utils.asyncSome([
                        `jerseyImages/${trimmedSport}/${maybeSize}${teamName.replace(/\s/g, '')}.png`,
                        `jerseyImages/${trimmedSport}/${maybeSize}${teamName}.png`,
                        `jerseyImages/${trimmedSport}/${maybeSize}Default-${teamType}.png`,
                        size
                            ? `jerseyImages/Default/${size}/Default-${teamType}.png`
                            : `jerseyImages/Default-${teamType}.png`
                    ], (filename) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const jersey = yield loadImage(filename);
                            if (jersey && mounted.current) {
                                setImage(jersey);
                                return true;
                            }
                            return false;
                        }
                        catch (e) {
                            return false;
                        }
                    }));
                }
                catch (e) {
                    console.log(e);
                }
            });
        })();
    }, [loadImage, sport, teamName, teamType, mounted]);
    if (image) {
        return React.createElement("img", Object.assign({ src: image, alt: 'Jersey for ' + teamName }, rest));
    }
    else {
        return null;
    }
};
export default Jersey;
//# sourceMappingURL=Jersey.js.map